<div class="py-4 px-2 md:p-6 lg:w-[var(--mixed-content-card-container-width)] lg:mx-auto">
  <dacks-content-header class="sr-only">{{ 'product-change.title' | translate }}</dacks-content-header>
  <div class="pl-2 md:pl-4 pb-6 text-sm lg:text-base">{{ 'delivery.legal_notice' | translate }}</div>
  @if (appState.isPersonalized$ | async) {
    <mat-slide-toggle class="md:hidden ml-2 pb-6" [checked]="appState.isPersonalProductChangeFilter"
                      (change)="changePersonalFilterState($event)">{{'filter-group.personalize_toggle' | translate}}</mat-slide-toggle>
  }
  <div class="flex flex-row items-center flex-wrap gap-4 pl-2 md:pl-4 pb-6">
    @if (appState.isPersonalized$ | async) {
      <div class="hidden md:block" >
        <mat-slide-toggle [checked]="appState.isPersonalProductChangeFilter"
                          (change)="changePersonalFilterState($event)">{{'filter-group.personalize_toggle' | translate}}</mat-slide-toggle>
      </div>
    }
    <!-- Workaround für "Button und offcanvas brauchen unterschiedlichen z-index wegen header."
         Da das offcanvas noch keine Konfig-Möglichkeit anbietet, wird z-index manuell außerhalb gewechselt -->
    <!-- Falls der Breakpoint für hidden geändert wird, muss auch im ts-File zu dieser Komponente der Breakpoint angepasst werden -->
    <div class="md:hidden" [ngClass]="{ 'z-index-topmost-plus-1': filterOffcanvasShown, 'z-index-reset': !filterOffcanvasShown }">
      <dackl-filter-off-canvas (click)="openfilterOffcanvas()">
        <myupdates-filter-product [context]="FilterContext.ProductChange">
        </myupdates-filter-product>
      </dackl-filter-off-canvas>
    </div>
    <div class="hidden md:block">
      <myupdates-filter-product [context]="FilterContext.ProductChange"></myupdates-filter-product>
    </div>
    @if (sortOrderSelections.length > 0) {
      <dackl-filter-single-select [label]="'product-change-cardview.sort_prefix' | translate" hideLabel="false"
                                  [selections]="sortOrderSelections"
                                  [(selectedValue)]="sortOrderSelection"
                                  (selectedValueChange)="sortOrderChanged()">
      </dackl-filter-single-select>
    }
    <myupdates-search-slot-slim class="block pr-2 w-full sm:w-80">
    </myupdates-search-slot-slim>
  </div>
  <div class="pb-[3.375rem]">
    @if ((viewModel$ | async); as viewModel) {
      @if (viewModel.flat.length > 0) {
        <div>
          <cdk-virtual-scroll-viewport #viewPort itemSize="304" minBufferPx="900" maxBufferPx="900" scrollWindow
                                       class="md:hidden md:w-full">
            <div class="md:hidden grid grid-cols-1 gap-4 mx-2 pt-3 mb-4">
              <ng-container *cdkVirtualFor="let productChange of viewModel.flat; let pcnr = index">
                <ng-container
                  *ngTemplateOutlet="card; context: {$implicit: productChange, nr:pcnr, breakpoint: ''}"></ng-container>
              </ng-container>
            </div>
          </cdk-virtual-scroll-viewport>
          <cdk-virtual-scroll-viewport #mdViewPort itemSize="277" minBufferPx="850" maxBufferPx="850" scrollWindow
                                       class="hidden md:block md:w-full lg:max-w-[73.5rem]">
            <div class="md:grid md:grid-cols-2 md:gap-6 mx-4 pt-5 mb-6">
              <ng-container *cdkVirtualFor="let row of viewModel.rows; let rownr = index">
                <!-- Hier wird any genutzt, da die Direktive cdkVirtualFor aktuell noch keine Typinformation übermittelt -->
                @for (productChange of $any(row.columns); track productChange; let colnr = $index) {
                  <ng-container
                    *ngTemplateOutlet="card; context: {$implicit: productChange, nr:rownr * 2 + colnr, breakpoint:'md:'}">
                  </ng-container>
                }
              </ng-container>
            </div>
          </cdk-virtual-scroll-viewport>
          <div class="md:w-full pt-8 lg:max-w-[73.5rem]">
            <div class="m-auto text-center">
              @if (viewModel.productChangesInView < viewModel.totalProductChanges) {
                <button mat-button (click)="nextPage()"
                        [attr.aria-label]="'product-change-cardview.aria_next_page_button' | translate">
                  {{ 'product-change-cardview.next_page_button' | translate }}
                </button>
              }
              @if (viewModel.productChangesInView >= viewModel.totalProductChanges) {
                <div class="dna20InteractiveText">
                  {{ 'product-change-cardview.no_next_page' | translate }}
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="pt-24 h-24 text-center font-semibold">
          {{ 'product-change-cardview.empty_product_change_list' | translate }}
        </div>
      }
    } @else {
      <div class="px-4">
        @if ((errorInfo$ | async); as errorInfo) {
          <myupdates-error-box class="error-box-white-style"
                               [errorTitle]="'product-change-cardview.error_cardview_title' | translate"
                               [errorText]="'product-change-cardview.error_cardview_text' | translate">
          </myupdates-error-box>
        } @else {
          <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
        }
      </div>
    }
  </div>
  <ng-template #card let-entry let-pcnr="nr" let-breakpoint="breakpoint">
    @if (toProductChange(entry); as productChange) {
      <myupdates-product-change-card
        [productChange]="productChange"
        [breakpoint]="breakpoint"
        [pcnr]="pcnr"
        [dateTranslation]="dateTranslation"
        [dateTranslationMonth]="dateTranslationMonth"
        (cardClick)="onClickCard($event)">
      </myupdates-product-change-card>
    }
  </ng-template>
</div>
